<template>
	<div id="ShippingModalComponent">
		<div class="modal fade static" id="shippingModalComponent" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" data-keyboard="false">
			<div class="modal-dialog modal-lg static">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">
                            <span v-if="item.id == 0">Nuevo </span>
                            Envío
                            <span v-if="item.id != 0">Nº {{item.id}}</span>
                             - 
                            <span :class="'text-uppercase badge badge-' + item.color">{{ item.status }}</span>
                        </h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="card card-info card-outline">
							<div class="card-body box-profile">
								<h3 class="profile-username text-center">{{ item.sendto }}</h3>

								<p class="text-muted text-center">{{ item.commentary }}</p>

								<ul class="list-group list-group-unbordered mb-3">
									<li class="list-group-item">
										<p>
											<b>Dirección:</b> <span>{{ item.address }}</span>
										</p>
										<p>
											<b>Comuna:</b> <span>{{ item.comuna }}</span>
										</p>
										<p>
											<b>Telefono:</b> <span>{{ item.phone }}</span>
											<b class="badge float-right" :class="(item.paid_shipping == 0) ? 'badge-warning' : ''">{{ (item.paid_shipping == 0) ? 'POR PAGAR' : 'CTA CTE' }}</b>
										</p>
									</li>
								</ul>
								<div :class="'p-3 mb-2 text-center bg-' + item.transport_color">
									<h2>{{ item.transport }}</h2>
									<small v-if="item.freight_order.trim() != ''">OF <span class="pointer" @dblclick="getInfoShippingCourrier(item)">{{ item.freight_order }}</span></small>
								</div>
								<div class="row">
									<label class="col-sm p-3 mb-2 text-center bg-secondary" for="barcodeOrPackages"
										:class="(item.packages == 0) ? 'border border-danger' : ''">
										Bultos
										<h2>{{ item.packages }}</h2>
									</label>
									<label class="col-sm p-3 mb-2 text-center bg-dark pointer" for="barcodeOrPackages"
										:class="(item.packages > 0 && item.weight == 0) ? 'border border-danger' : ''">
										Peso
										<h2>{{ item.weight }}</h2>
									</label>
								</div>
                                <ul class="nav nav-tabs" id="myTab" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Solicitud Envío</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Seguimiento</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab" aria-controls="contact" aria-selected="false" v-if="environment == 'DEV'">All Content</a>
                                    </li>
                                </ul>
                                <div class="tab-content" id="myTabContent">
                                    <div class="tab-pane fade margin-top5 show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                        <table class="table table-sm table-12">
                                            <thead class="text-center">
                                                <tr>
                                                    <th>Nº Solicitud de envío</th>
                                                    <th>Fecha</th>
                                                    <th>Comentario</th>
                                                    <th>Estado</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(it, index) in item.shipping_shippings_request" :key="index">
                                                    <td class="text-center">{{ it.shipping_request_id }}</td>
                                                    <td class="text-center">{{ it.created_at | formatDate }}</td>
                                                    <td>{{ it.commentary }}</td>
                                                    <td class="text-center">{{ it.status }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="tab-pane fade margin-top5" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                        <table class="table table-sm table-12">
                                            <thead class="text-center">
                                                <tr>
                                                    <th>Fecha</th>
                                                    <th>Acción</th>
                                                    <th>Observación</th>
                                                    <th>Usuario</th>
                                                    <th>IP</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(it, index) in item.shipping_trackings_shipping" :key="index" :title="it.observation">
                                                    <td>{{ it.created_at | formatDate}}</td>
                                                    <td>{{ it.description }}</td>
                                                    <td>{{ it.observation }}</td>
                                                    <td>{{ it.user }}</td>
                                                    <td>{{ it.ipv4 }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="tab-pane fade margin-top5" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                                        <pre>
                                            {{ item }}
                                        </pre>
                                    </div>
                                </div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary" v-if="item.id == 0">Guardar Envío</button>
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import mixin from '@/mixins'
	export default {
		name: 'ShippingModalComponent',
        mixins: [mixin],
        props: ['item', ''],
		data () {
			return {
			}
		},
		computed: {
		},
		methods: {
            getInfoShippingCourrier(item) {
                this.$emit('getInfoShippingCourrier', item)
            }
        }
	}</script>

	<!-- Add "scoped" attribute to limit CSS to this component only -->
	<style scoped lang="scss">
</style>
